<template>
  <el-select
    :value="value"
    size="small"
    @change="handleChange"
    :placeholder="allowCreate ? '请选择或输入后回车新建' : '请选择标签'"
    style="width: 100%"
    filterable
    clearable
    :allow-create="allowCreate"
    default-first-option
  >
    <el-option
      v-for="(item, index) in lists"
      :key="item + index"
      :label="item"
      :value="item"
    ></el-option>
  </el-select>
</template>

<script>
import { attachmentList } from '@/service/getData'

export default {
  props: {
    value: '',
    allowCreate: {
      type: Boolean,
      default: false,
    },
    itemId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      lists: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      let res = await attachmentList({
        get_tag: true,
        item_id: this.itemId,
      })
      if (res.status == 0) {
        this.lists = res.data
      }
    },
    handleChange(e) {
      this.$emit('input', e)
    },
  },
}
</script>
<style>
.select-err .el-input__inner {
  border-color: #f56c6c;
}
</style>